export default class WidgetError extends Error {
    /**
     * The name of the error.
     *
     * @type {string}
     */
    static code = 'GENERIC';
    /**
     * Constructs the error.
     *
     * @param {string} message
     */
    constructor(message) {
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, WidgetError.prototype);
        this.name = this.getCode();
    }
    /**
     * Get the code name of the error.
     *
     * @return {string}
     */
    getCode() {
        return this.constructor.code;
    }
}
//# sourceMappingURL=WidgetError.js.map